import React from "react"

export const Calendar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M19.4643 4.09998H17.4286V1.8656C17.4286 1.58201 17.1996 1.34998 16.9196
        1.34998H16.5804C16.3004 1.34998 16.0714 1.58201 16.0714
        1.8656V4.09998H7.92857V1.8656C7.92857 1.58201 7.69955 1.34998 7.41964
        1.34998H7.08036C6.80045 1.34998 6.57143 1.58201 6.57143 1.8656V4.09998H4.53571C3.41183
        4.09998 2.5 5.0238 2.5 6.16248V21.2875C2.5 22.4261 3.41183 23.35 4.53571 23.35H19.4643C20.5882
        23.35 21.5 22.4261 21.5 21.2875V6.16248C21.5 5.0238 20.5882 4.09998 19.4643 4.09998ZM4.53571
        5.47498H19.4643C19.8375 5.47498 20.1429 5.78435 20.1429 6.16248V8.22498H3.85714V6.16248C3.85714
        5.78435 4.1625 5.47498 4.53571 5.47498ZM19.4643 21.975H4.53571C4.1625 21.975 3.85714 21.6656 3.85714
        21.2875V9.59998H20.1429V21.2875C20.1429 21.6656 19.8375 21.975 19.4643 21.975ZM8.77679 15.1H7.08036C6.80045
        15.1 6.57143 14.8679 6.57143 14.5844V12.8656C6.57143 12.582 6.80045 12.35 7.08036 12.35H8.77679C9.0567 12.35
        9.28571 12.582 9.28571 12.8656V14.5844C9.28571 14.8679 9.0567 15.1 8.77679 15.1ZM12.8482 15.1H11.1518C10.8719
        15.1 10.6429 14.8679 10.6429 14.5844V12.8656C10.6429 12.582 10.8719 12.35 11.1518 12.35H12.8482C13.1281 12.35
        13.3571 12.582 13.3571 12.8656V14.5844C13.3571 14.8679 13.1281 15.1 12.8482 15.1ZM16.9196 15.1H15.2232C14.9433
        15.1 14.7143 14.8679 14.7143 14.5844V12.8656C14.7143 12.582 14.9433 12.35 15.2232 12.35H16.9196C17.1996 12.35
        17.4286 12.582 17.4286 12.8656V14.5844C17.4286 14.8679 17.1996 15.1 16.9196 15.1ZM12.8482 19.225H11.1518C10.8719
        19.225 10.6429 18.9929 10.6429 18.7094V16.9906C10.6429 16.707 10.8719 16.475 11.1518 16.475H12.8482C13.1281
        16.475 13.3571 16.707 13.3571 16.9906V18.7094C13.3571 18.9929 13.1281 19.225 12.8482 19.225ZM8.77679
        19.225H7.08036C6.80045 19.225 6.57143 18.9929 6.57143 18.7094V16.9906C6.57143 16.707 6.80045 16.475
        7.08036 16.475H8.77679C9.0567 16.475 9.28571 16.707 9.28571 16.9906V18.7094C9.28571 18.9929 9.0567 19.225
        8.77679 19.225ZM16.9196 19.225H15.2232C14.9433 19.225 14.7143 18.9929 14.7143 18.7094V16.9906C14.7143 16.707
        14.9433 16.475 15.2232 16.475H16.9196C17.1996 16.475 17.4286 16.707 17.4286 16.9906V18.7094C17.4286 18.9929
        17.1996 19.225 16.9196 19.225Z"
        fill="#0374D6"
      />
    </svg>
  )
}
